import Poller from '../../../modules/Poller';

/**
 * PromisePoller is a poller that returns a promise.
 *
 * On success, that promise will resolve. On failure it will reject.
 *
 *
 * Example usage
 *
 * const placeOrderPoller = new PromisePoller('api/place-order', 'api/order-status');
 *
 * placeOrderPoller
 *   .execute(postRequestData) // Then just use like any other promise
 *   .then(successCallback) // Your callbacks can return to pass data to another 'then' in the chain
 *   .catch(errorCallback; // Or throw to trigger the catch block
 *
 */

export default class PromisePoller {
  // For now, this will call the legacy poller, but gradually we can migrate functionality from it across
  constructor(postURL, pollURL, maxTimeout, sendBodyOnPoll) {
    this.postURL = postURL;
    this.pollURL = pollURL;
    this.maxTimeout = maxTimeout;
    this.sendBodyOnPoll = sendBodyOnPoll;
  
    this.getPollerOptions = this.getPollerOptions.bind(this);
    this.reset = this.reset.bind(this);
    this.execute = this.execute.bind(this);
    this.runPoller = this.runPoller.bind(this);
  }
  
  getPollerOptions() {
    const {
      postURL, pollURL, maxTimeout, sendBodyOnPoll,
    } = this;
    return {
      postURL, pollURL, maxTimeout, sendBodyOnPoll,
    };
  }
  
  reset(callback) {
    return new Promise((resolve, reject) => {
      if (this.currentPoller) {
        this.currentPoller.stopPoller();
      }
      
      this.currentPoller = new Poller(this.getPollerOptions(), resolve, reject);
      
      callback();
    });
  }
  
  execute(requestData) {
    return this.reset(() => {
      this.currentPoller.execPost(JSON.stringify(requestData), 'POST', undefined, 'application/json');
    });
  }
  
  runPoller() {
    return this.reset(() => {
      this.currentPoller.runPoller();
    });
  }
}
